import { Navigate, createBrowserRouter } from "react-router";
import type { RouteObject } from "react-router";
import { AccountPage } from "../account/AccountPage";
import { AdminHome, AdminLayout } from "../admin/AdminLayout";
import { MasterDataPage } from "../admin/masterdata/MasterDataPage";
import { UsersPage } from "../admin/users/UsersPage";
import { ApiKeysPage } from "../admin/apikeys/ApiKeysPage";
import { features } from "../auth/store";
import { LoginPage } from "../login/LoginPage";
import { MapEntry } from "../map/MapEntry";
import { NotFoundPage, Shell } from "./App";
import { RequireAuth, RequireFeature } from "./guards";
import { PublicMapsPage } from "../admin/publicmaps/PublicMapsPage";
import { TablePage } from "../table/TablePage";

export const appRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Shell />,
    children: [
      { path: "login", element: <LoginPage /> },
      { path: "table/:tableName", element: <TablePage /> },
      { index: true, element: <MapEntry /> },
      {
        element: <RequireAuth />,
        children: [
          { path: "account", element: <AccountPage /> },
          {
            path: "admin",
            element: <AdminLayout />,
            children: [
              { index: true, element: <AdminHome /> },
              {
                element: <RequireFeature feature={features.masterData} />,
                children: [
                  { path: "masterdata", element: <MasterDataPage root={null} /> },
                  { path: "masterdata/maps", element: <MasterDataPage root="MAP" /> },
                  { path: "masterdata/layers", element: <MasterDataPage root="LAYER" /> },
                  { path: "maps", element: <Navigate to="/admin/masterdata/maps" replace /> },
                  { path: "layers", element: <Navigate to="/admin/masterdata/layers" replace /> }
                ]
              },
              {
                element: <RequireFeature feature={features.userAdmin} />,
                children: [
                  { path: "users", element: <UsersPage /> },
                  { path: "apikeys", element: <ApiKeysPage /> }
                ]
              },
              { element: <RequireFeature feature={features.publicMap} />, children: [{ path: "publicmaps", element: <PublicMapsPage /> }] },
              { path: "*", element: <Navigate to="/admin" replace /> }
            ]
          }
        ]
      },
      { path: "*", element: <NotFoundPage /> }
    ]
  }
];

export function createAppRouter(basename: string) {
  return createBrowserRouter(appRoutes, { basename: basename === "/" ? undefined : basename });
}
